export const getType = obj => {
    if (!obj) {
        return null;
    }
    return Object.keys(obj).reduce((acc, cur) => {
        const type = typeof obj[cur];
        const isArray = Array.isArray(obj[cur]);
        if (type === 'object' && !isArray) {
            acc[cur] = getType(obj[cur]);
        } else if (!isArray) {
            acc[cur] = type;
        }
        return acc;
    }, {});
};

export const EventType = {
    statusFull: 'string',
    fullName: 'string',
    shortName: 'string',
    fullScore: 'string',
    homeName: 'string',
    awayName: 'string',
    homeShortName: 'string',
    awayShortName: 'string',
    country: 'string',
    tournamentName: 'string',
    tournamentYear: 'string',
    sport: 'string',
    score: { home: 'string', away: 'string' },
    properties: {
        round: 'string',
        venueName: 'string'
    }
};

export const TournamentType = {
    name: 'string',
    gender: 'string',
    countryName: 'string',
    currentRound: 'string',
    currentSeason: { id: 'number', year: 'string' }
};

export const IncidentType = {
    min: 'number',
    type: 'string',
    subtype: 'string',
    teamName: 'string',
    participantName: 'string'
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/messages/types.js
 **/